import type { FC } from 'react';

import { Button, type ButtonVariant } from 'components/Button/Button';
import { Permissions } from 'containers/Permissions/Permissions';
import { useDownloadCliLog } from 'utils/hooks/useDownloadCliLog';

type Props = {
  btnText: string;
  className?: string;
  collection: string;
  dataKey: string;
  fileName: string;
  variant?: ButtonVariant;
};

export const DownloadCliLog: FC<Props> = (props) => {
  const { loading, downloadLog } = useDownloadCliLog(props);

  return (
    <Permissions requiredScope={['settings']}>
      <Button
        className={props.className}
        variant={props.variant ?? 'secondary'}
        onClick={downloadLog}
        icon='fa-file-lines'
        loading={loading === 'LOADING'}
        size='xxs'
        type='button'
      >
        {props.btnText}
      </Button>
    </Permissions>
  );
};
